import React, { useEffect, useState } from "react";
import "./IntrodectoryVideo.scss";
import { Box, Button } from "@mui/material";
import Unpprovevideo from "../../components/unapprovevideo/Unpprovevideo";
import VideoUploadDialogBox from "../../components/VideoUploadDialogBox/VideoUploadDialogBox";

const IntrodectoryVideo: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(true);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  useEffect(() => {
    // setSelectedFile((prev) => {
    //   return prev;
    // });
  }, [refresh]);
  const onclose = () => {
    setOpen(false);
    setSelectedFile(null);
  };
  return (
    <Box>
      {/* IntrodectoryVideo Page */}
      <Box sx={{ textAlign: "center", marginBottom: "10px" }}>
        <Button sx={activeButtonStyle} onClick={() => setOpen(true)}>
          Upload Introductory video
        </Button>

        <Unpprovevideo refresh />
      </Box>
      <VideoUploadDialogBox
        open={open}
        onClose={onclose}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
      />
    </Box>
  );
};
const activeButtonStyle = {
  color: "Purple",
  fontSize: "16px",
  fontWeight: "bold",
  border: "1px solid",
  "&:hover": { background: "white" },
};

export default IntrodectoryVideo;
